export default "/images/vendor/flag-icon-css/flags/4x3/ir.svg?12e7432b428f8d631eb5fede40b2e095";